// Canonical device-ID helper.
//
// One persistent per-browser/device id, used for two things that MUST agree:
//   1. notification sender-exclusion (sender_device_id travels to the server so
//      the sender does not get a push for their own action)
//   2. realtime self-broadcast filtering (own broadcasts are dropped client-side)
//
// Previously duplicated in api.ts and usePushNotifications.ts; if one diverged
// (format/key) sender-exclusion silently broke (triple-review 2026-06-11 C8).
// Single source of truth here so both paths share the exact same id.
import { storage } from './storage';

const DEVICE_ID_KEY = 'shopman_device_id';

export function getDeviceId(): string {
  let deviceId = storage.get(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = 'dev_' + crypto.randomUUID();
    storage.set(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
}
